import styles from 'wienenergiedesignsystem/components/Figure/Figure.module.scss';
import React from 'react';
import Content from 'wienenergiedesignsystem/components/Content/Content';
import classNames from 'classnames';
import Image from 'wienenergiedesignsystem/components/Image/Image';

var Figure = function Figure(_ref) {
  var srcSet = _ref.srcSet,
      src = _ref.src,
      sizes = _ref.sizes,
      title = _ref.title,
      alt = _ref.alt,
      caption = _ref.caption,
      variant = _ref.variant;
  return /*#__PURE__*/React.createElement("figure", {
    className: classNames(styles.figure)
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames(styles[variant || 'default'])
  }, /*#__PURE__*/React.createElement(Image, {
    className: styles.image,
    src: src,
    sizes: sizes,
    srcSet: srcSet,
    alt: alt,
    title: title
  })), caption && /*#__PURE__*/React.createElement(Content, {
    className: styles.caption,
    as: "figcaption",
    size: "sm"
  }, caption));
};

Figure.defaultProps = {
  srcSet: null,
  sizes: null,
  title: null,
  caption: null,
  variant: 'default'
};
export default Figure;